// src/sections/ZaehlerSection.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";

export default function ZaehlerSection({ selectedAnlageId }) {
  const [zaehlernummer, setZaehlernummer] = useState("");
  const [wandlerfaktor, setWandlerfaktor] = useState("");

useEffect(() => {
  if (!selectedAnlageId) return;

  axios
    .get(`${process.env.REACT_APP_API_URL}/api/zaehleranlage/anlage/${selectedAnlageId}`)
    .then((res) => {
      setZaehlernummer(res.data.zaehlernummer ?? "");
      setWandlerfaktor(
        res.data.wandlerFaktor !== null
          ? res.data.wandlerFaktor.toString()
          : ""
      );
    })
    .catch(() => {
      setZaehlernummer("");
      setWandlerfaktor("");
    });
}, [selectedAnlageId]);


const handleSave = async () => {
  if (!zaehlernummer.trim()) {
    showError("Fehler!", "Bitte Zählernummer eingeben.");
    return;
  }

const payload = {
  anlage: { id: selectedAnlageId },
  zaehlernummer: zaehlernummer,
  wandlerFaktor: wandlerfaktor === "" ? null : parseFloat(wandlerfaktor),
};

  try {
    // try load existing
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/zaehleranlage/anlage/${selectedAnlageId}`
    );

    // update
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/zaehleranlage/${res.data.id}`,
      payload
    );

    showSuccess("Gespeichert", "Zählerdaten wurden aktualisiert");
  } catch {
    // create
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/zaehleranlage`,
      payload
    );

    showSuccess("Gespeichert", "Zählerdaten wurden gespeichert");
  }
};

  return (
        <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3 style={{ marginBottom: 16, color: "#050505", fontWeight: 700, textTransform: "uppercase", marginLeft: 0,
          fontSize: "24px"}}>
        ZÄHLER
      </h3>

      <div style={{ background: "#f7fafc", padding: 16, borderRadius: 8 }}>
        <div style={{ display: "grid", gridTemplateColumns: "220px 1fr", gap: 12, alignItems: "center", marginBottom: 12 }}>
          <label style={{ fontWeight: 600 }}>Zählernummer</label>
          <input
            type="text"
            value={zaehlernummer}
            onChange={(e) => setZaehlernummer(e.target.value)}
            style={{ padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc", width: "100%" }}
            placeholder="Zählernummer eingeben"
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "220px 200px", gap: 12, alignItems: "center" }}>
          <label style={{ fontWeight: 600 }}>Wandlerfaktor</label>
          <input
            type="number"
            step="0.01"
            value={wandlerfaktor}
            onChange={(e) => setWandlerfaktor(e.target.value)}
            style={{ padding: "8px 10px", borderRadius: 6, border: "1px solid #ccc" }}
            placeholder="z. B. 1.00"
          />
        </div>

        <Button
          type="button"
           bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
          onClick={handleSave}
        >
          Speichern Zähler
        </Button>
      </div>
    </Box>
  );
}